const rootPath = typeof window !== 'undefined'
  ? window.__teamsiteroot__
  : process.env.TEAMSITEROOT || 'http://localhost'

export default rootPath